import { get, post } from '@/api/index';
//小米考试
export const xiaomilist = params => get(`/api/newpaper/v1/xiaomi/list`, params);//小米我的考试列表
export const xiaomiresult = params => get(`/api/newpaper/v1/xiaomi/result`, params);//小米我的考试结果
export const xiaomicertificate = params => get(`/api/newpaper/v1/xiaomi/certificate`, params);//小米我的考试准考证

